module.exports = __webpack_public_path__ + "static/tool-results-ab71b453be2316bddd4c0822fc938f13.png";